import React from "react";
import ReactWOW from "react-wow";
import { $t } from './i18n';
import { transformArray } from '@/utils/helper';

class CardList extends React.Component {
  render() {
    const { list = [], id, canAnimation = true } = this.props
    return (
      <ul className="card-wrapper" id={id}>
        {
          list.map((item, index) => {
            const desc = transformArray(item.desc)
            return (
              <ReactWOW animation={canAnimation ? 'fadeInUp' : ''} delay={`${index * 0.1}s`} key={item.title || index}>
                <li className="item">
                  { item.icon ? <img className="img" src={item.icon} alt={item.icon} /> : null }
                  <div className="content">
                  { item.title ?  <p className="title">{$t(item.title)}</p>: null }
                    <div className="desc-wrapper">
                      {
                        desc.map(text => <p className="desc" key={text}>{text}</p>)
                      }
                    </div>
                    { item.explain ? <p className="explain">{$t(item.explain)}</p> : null}
                  </div>
                </li>
              </ReactWOW>
            )
          })
        }
      </ul>
    );
  }
}

export default CardList;
